import { RootObject, IContet } from '../../type';

import './style.less';

const easyDeployIntro = (props: RootObject["easyDeployIntro"]) => {
    const { content } = props;

    const onJump = (data: IContet) => {
        if (data.jumpLink) {
            window.open(data.jumpLink, '_blank')
        }
    }

    return (
        <div className="easy-deploy-intro" >
            <div className="easy-deploy-intro-item-wrapper" >
                {
                    content.map(item => (
                        <div
                            key={item.title}
                            onClick={() => onJump(item)}
                            className="easy-deploy-intro-item" >
                            <div
                                style={{ backgroundImage: `url(${item.icon})` }}
                                className="easy-deploy-intro-item-icon" />
                            <div className="easy-deploy-intro-item-text">
                                <span>{item.title}</span>
                                <span>{item.desc}</span>
                            </div>
                        </div>
                    ))
                }
            </div>
            <div className="easy-deploy-intro-line"></div>

        </div>
    )
}

export default easyDeployIntro;